const routes = {
  home: "/",
  download: "/download",
  contact: "/contact",
  at_home: "/at-home",
  at_the_hospital: "/at-the-hospital",
  live_healthy: "/live-healthy",
  list_specialties: "/list-specialties",
  list_facilities: "/list-facilities",
  doctor_list: "/doctor-list",
  health_guard: "/health-guard",
  partner_with_tobecare: "/partner-with-tobecare",
  cooperate_with_tobecare: "/cooperate-with-tobecare",
  business_digital_transformation_package:
    "/business-digital-transformation-package",
  general_examination: "/general-examination",
  medical_test: "/medical-test",
  mental_health: "/mental-health",
  dental_checkup: "/dental-checkup",
  outstanding_specialties: "/outstanding-specialties",
  media_product: "/media-product",
  detail_product: "/detail-product",
  store: "/store",
  profile: "/dashboard/profile",
  relatives: "/dashboard/profile/relatives",
  add_your_relatives: "/dashboard/profile/relatives/add-your-relatives",
  edit_your_relatives: "/dashboard/profile/relatives/edit-your-relatives",
  // doctor_account: "/dashboard/profile/doctor-account",
  doctor_account_management: "/dashboard/profile/doctor-account-management",
  health_check_booking: "/dashboard/health-check-booking",
  work_management: "/dashboard/profile/work-management",
  changePassword: "/dashboard/change-password",
  notification: "/dashboard/notification",
  appointment: "/dashboard/appointment",
  doctor_job: "/dashboard/doctor-job",
  wallet: "/dashboard/wallet",
  product_order: "/dashboard/product-order",
  checkout: "/dashboard/checkout",
  medical_records: "/dashboard/medical-records",
  wallet_address: "/dashboard/wallet-address",
  edit_profile: "/dashboard/profile/edit-profile",
  help_center: "/dashboard/profile/help-center",
  data_delection: "/dashboard/profile/data-delection",
  how_to_complete_daily_tasks_and_redeem_rewards:
    "/dashboard/profile/help-center/how-to-complete-daily-tasks-and-redeem-rewards",
  how_to_redeem_voucher_and_make_appointment:
    "/dashboard/profile/help-center/how-to-redeem-voucher-and-make-appointment",
  faucet_point: "/dashboard/profile/help-center/how-to-get-faucet-points",
  register_doctor_account:
    "/dashboard/profile/doctor-account-management/register-doctor-account",
  update_doctor_account:
    "/dashboard/profile/doctor-account-management/update-doctor-account",
  manage_time_working: "/dashboard/profile/work-management/manage-time-working",
  managing_discount_vouchers:
    "/dashboard/profile/work-management/managing-discount-vouchers",
  create_voucher:
    "/dashboard/profile/work-management/managing-discount-vouchers/create-voucher",
  update_voucher:
    "/dashboard/profile/work-management/managing-discount-vouchers/update-voucher",
  update_time_marker:
    "/dashboard/profile/work-management/manage-time-working/update-time-marker",
  create_time_marker:
    "/dashboard/profile/work-management/manage-time-working/create-time-marker",
  medical_examination_price_management:
    "/dashboard/profile/work-management/medical-examination-price-management",
  create_medical_examination_price:
    "/dashboard/profile/work-management/medical-examination-price-management/create-medical-examination-price",
  financial_management: "/dashboard/profile/financial-management",
  cryptocurrency_wallet_management:
    "/dashboard/profile/financial-management/cryptocurrency-wallet-management",
  service_price_management:
    "/dashboard/profile/work-management/medical-examination-price-management/service-price-management",
  create_service_price:
    "/dashboard/profile/work-management/medical-examination-price-management/create-service-price",
  update_service_price:
    "/dashboard/profile/work-management/medical-examination-price-management/update-service-price",
  update_medical_examination_price:
    "/dashboard/profile/work-management/medical-examination-price-management/update-medical-examination-price",
  detail_medical_facility: "/detail-medical-facility",
  detail_doctor_specialty: "/detail-doctor-specialty",
  detail_doctor: "/detail-doctor",
  manage_cooperate_medical_facility:
    "/dashboard/manage-cooperate-medical-facility",
  create_medical_facility:
    "/dashboard/manage-cooperate-medical-facility/create-medical-facility",
  update_medical_facility:
    "/dashboard/manage-cooperate-medical-facility/update-medical-facility",
  free_doctor_consultation: "/free-doctor-consultation",
  my_history: "/free-doctor-consultation/my-history",
  list_answer_questions: "/free-doctor-consultation/list-answer-questions",
  // PrivacyPolicy: "/policy/privacy-policy",
  // TemrsOfService: "/policy/temrs-of-service",
  TemrsOfService: "/policy/temrs-of-service",
  PrivacyPolicy: "/policy/privacy-policy",
};

export default routes;
